import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.routes),
  },
  {
    path: 'error/:code',
    loadComponent: () =>
      import('./features/system/pages/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
  },
  {
    path: '400',
    loadComponent: () =>
      import('./features/system/pages/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
    data: { code: '400', title: 'Solicitud inválida', message: 'No se pudo procesar la solicitud.' },
  },
  {
    path: '401',
    loadComponent: () =>
      import('./features/system/pages/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
    data: { code: '401', title: 'No autorizado', message: 'Debes iniciar sesión para continuar.' },
  },
  {
    path: '403',
    loadComponent: () =>
      import('./features/system/pages/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
    data: { code: '403', title: 'Prohibido', message: 'No tienes acceso a este recurso.' },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./features/system/pages/error-page/error-page.component').then(
        (m) => m.ErrorPageComponent,
      ),
    data: {
      code: '500',
      title: 'Error del servidor',
      message: 'Algo salió mal de nuestro lado. Intenta nuevamente más tarde.',
    },
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'usuarios',
        redirectTo: 'admin/usuarios',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/pages/home/home.component').then((m) => m.HomeComponent),
        data: { title: 'Dashboard' },
      },
      {
        path: 'laboratorios/reportes',
        loadChildren: () => import('./features/reportes/reportes.routes').then((m) => m.routes),
      },
      {
        path: 'laboratorios/tableros',
        loadChildren: () => import('./features/tableros/tableros.routes').then((m) => m.routes),
      },
      {
        path: 'perfil',
        loadComponent: () =>
          import('./features/perfil/pages/perfil/perfil.component').then((m) => m.PerfilComponent),
        data: { title: 'Perfil' },
      },
      {
        path: 'admin',
        loadChildren: () => import('./features/admin/admin.routes').then((m) => m.routes),
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      }
    ],
  },
  {
    path: '**',
    redirectTo: '/error/404',
  },
];
